import {all, call, delay, fork, put, select, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import {get, puto} from 'bukku/shared/ApiService';
import { plural, t } from '@lingui/macro';
import { getImportedItemsDetail } from './getImportedItemsDetail';

// Read opening
export function* readRequest() {
    yield takeEvery(actions.OPENING_READ_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/opening', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.OPENING_READ_SUCCESS,
                transaction: data.transaction,
            });
        }
        catch (error) {
            yield put({
                type: actions.OPENING_READ_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readSuccess() {
    yield takeEvery(actions.OPENING_READ_SUCCESS, () => {});
}
export function* readError() {
    yield takeEvery(actions.OPENING_READ_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update opening
export function* updateRequest() {
    yield takeEvery(actions.OPENING_UPDATE_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });

            context.allow_intercept = true;
            yield call(puto, '/opening', request, context);

            // OK
            yield put({
                type: actions.OPENING_UPDATE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.OPENING_UPDATE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateSuccess() {
    yield takeEvery(actions.OPENING_UPDATE_SUCCESS, () => {});
}
export function* updateError() {
    yield takeEvery(actions.OPENING_UPDATE_ERROR, () => {});
}

/**
 * This is called when performing validation before going to next page in Opening Balance.
 * Will perform 3 actions
 * 1. message.warning DOM
 * 2. Jump to the PAGE with first error line
 * 3. Scroll to the first error line
 */
export function* scrollToErrorLine() {
    yield takeEvery(actions.OPENING_SCROLL_TO_ERROR_LINE, function* ({
        tableName, errorItem, allErrorItems,
    }) {
        // const openingItems = yield select(state => state.Editable[tableName].items);
        const openingPagination = yield select(state => state.Opening.pagination[tableName]);

        // Error checking
        let errorPage = null;
        // let errorLine = null;

        errorPage = Math.ceil((errorItem.line) / openingPagination.pageSize);
        // errorLine = (errorItem.line % openingPagination.pageSize);

        // Has Error
        if (errorItem) {
            const {
                line,
                // dirty,

                contact_name_not_found,
                hasNumberError,
                hasNumberErrorMsg,
                hasTagIdsErrorMsg,
            } = errorItem;

            const hasMoreError = allErrorItems.length > 1;
            const otherErrorCount = allErrorItems.length - 1;

            if (contact_name_not_found)
                message.warning(t`Line: ${line}: Contact not found. `);
            else if (hasNumberError)
                message.warning(t`Line: ${line}: ${hasNumberErrorMsg}`);
            else if (hasTagIdsErrorMsg)
                message.warning(t`Line: ${line}: ${hasTagIdsErrorMsg}`);
            else
                message.warning(t`Line: ${line}: Please check for fields highlighted in red.`);

            if (hasMoreError) {
                message.warning(t`Problems were found in another ${plural(otherErrorCount, {
                    one: '# line',
                    other: '# lines',
                })}. Please check for fields highlighted in red.`);
            }

            // scroll to the page with the first error
            if (errorPage !== openingPagination.current) {
                yield put({
                    type: actions.OPENING_SET_PAGINATION,
                    tableName,
                    paginationData: {
                        ...openingPagination,
                        current: errorPage,
                    },
                });
            }

            // wait for page change and render rows to complete
            yield delay(100);

            const {
                key,
            } = errorItem;
            const errorDomId = `line${line}-${key}`;
            const errorRowDom = document.getElementById(errorDomId);

            // scroll error first error line into view
            if (errorRowDom)
                errorRowDom.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });

            return false;
        }

        // OK
        return true;
    });
}

export function* readImportedProductsDetailRequest() {
    yield takeEvery(actions.OPENING_READ_IMPORTED_PRODUCTS_DETAIL_REQUEST, function* ({
        allProductIds,
    }) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });

            const importedProductsDetailList = yield getImportedItemsDetail(allProductIds);

            yield put({
                type: actions.OPENING_READ_IMPORTED_PRODUCTS_DETAIL_SUCCESS,
                importedProductsDetailList,
            });
        }
        catch (error) {
            yield put({
                type: actions.OPENING_READ_IMPORTED_PRODUCTS_DETAIL_ERROR,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readImportedProductsDetailSuccess() {
    yield takeEvery(actions.OPENING_READ_IMPORTED_PRODUCTS_DETAIL_SUCCESS, () => {});
}
export function* readImportedProductsDetailError() {
    yield takeEvery(actions.OPENING_READ_IMPORTED_PRODUCTS_DETAIL_ERROR, () => {});
}

export default function* rootSaga() {
    yield all([
        fork(readRequest),
        fork(readSuccess),
        fork(readError),
        fork(updateRequest),
        fork(updateSuccess),
        fork(updateError),

        fork(readImportedProductsDetailRequest),
        fork(readImportedProductsDetailSuccess),
        fork(readImportedProductsDetailError),

        fork(scrollToErrorLine),
    ]);
}
